import {Link} from "react-router-dom";
import useExtraFields from "../framework/hooks/useExtraHook";
import NieuwsbriefForm from "./form/NieuwsbriefForm";

export default function Footer() {
    const extraFields = useExtraFields();

    return (
        <div className="footer-area logo-light pt-130 pb-135 pt-xs-60 pb-xs-60">
            <div className="container">
                <div className="row">
                    <div className="col-xl-7 col-lg-7">
                        <div className="footer-content">
                            <div className="title">
                                <h1>Laten we samenwerken!</h1>
                            </div>
                            <div className="footer-info">
                                <h4>Bandwerk merkenbouwers</h4>
                                <div className="text">
                                    <p>{extraFields?.contact_adres}</p>
                                    <p>{extraFields?.contact_postcode} {extraFields?.contact_plaats}</p>
                                </div>
                                <a href={'tel:'+extraFields?.contact_tel}>{extraFields?.contact_tel}</a>
                                <a href={'mailto:'+extraFields?.contact_email}>{extraFields?.contact_email}</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-5">
                        <div className="social-icon-wrap">
                            <p>Check onze socials</p>
                            <div className="icon-wrap">
                                <a href={extraFields?.socials_facebook}>
                                    <i className="fa-brands fa-facebook-f" />
                                </a>
                                <a href={extraFields?.socials_instagram}>
                                    <i className="fa-brands fa-instagram" />
                                </a>
                                <a href={extraFields?.socials_linkedin}>
                                    <i className="fa-brands fa-linkedin-in" />
                                </a>
                            </div>
                        </div>
                        <NieuwsbriefForm />
                    </div>
                </div>
            </div>
        </div>
    );
}
